<template>
  <div>
    <b-card v-show="mostrarTabela" no-body>
      <b-card-header>
        <span class="h5">PERFIS DE ACESSO</span>
      </b-card-header>
      <b-card-body>
        <app-tabela idTabela="tblPerfisAcesso"
          :itens="perfisAcesso"
          :campos="campos"
          :itensPorPagina="itensPorPagina">
          <template slot="botoes">
            <b-button-group class="float-right">
              <b-button variant="success" @click.stop="inserirPerfilAcesso()" v-if="$temAcessoView('CTRLACS-PA-01')">Inserir Perfil de Acesso</b-button>
            </b-button-group>
          </template>
          <template slot="acoes" slot-scope="data">
            <span class="text-primary" v-if="$temAcessoView('CTRLACS-PA-02')"><i class="fa fa-info-circle fa-lg icon-button" title="Detalhar" @click.stop="detalharPerfilAcesso(data.perfilAcessoId)"></i></span>
          </template>
        </app-tabela>
      </b-card-body>
    </b-card>
    <router-view></router-view>
  </div>
</template>

<script>
import PerfisAcessoServicos from './PerfisAcessoServicos.js'

export default {
  data () {
    return {
      perfisAcesso: [],
      campos: [
        {
          key: 'codPerfilAcesso',
          label: 'Código',
          sortable: true,
          filterable: true
        },
        {
          key: 'descricaoPerfilAcesso',
          label: 'Descrição do perfil de acesso',
          sortable: true,
          filterable: true
        },
        // {
        //   key: 'caFlag',
        //   label: 'Nível'
        // },
        {
          key: 'acoes',
          label: 'Ações'
        }
      ],
      itensPorPagina: 10
    }
  },
  methods: {
    obterPerfisAcesso () {
      this.$store.dispatch('addRequest')
      PerfisAcessoServicos.obterTodos()
        .then((response) => {
          if (response) {
            if (response.success) {
              this.perfisAcesso = response.data
            } else {
              this.$toast.error(response.errors, 'ERROR', this.$toastConfig.error)
            }
          }
          this.$store.dispatch('removeRequest')
        })
    },

    inserirPerfilAcesso () {
      this.$router.push({ name: `${this.$route.name}_Inserir` })
    },

    detalharPerfilAcesso (id) {
      this.$router.push({
        name: `${this.$route.name}_Detalhar`,
        params: {
          perfilAcessoId: id
        }
      })
    }
  },

  created () {
    this.obterPerfisAcesso()
  },

  computed: {
    mostrarTabela () {
      return this.$route.name === 'PerfisAcesso'
    }
  },

  watch: {
    '$route' (to, from) {
      if (to.name === 'PerfisAcesso') {
        if (this.$store.getters.recarregar) {
          this.obterPerfisAcesso()
          this.$store.dispatch('setRecarregar', false)
        }
      }
    }
  }
}
</script>